import { render, staticRenderFns } from "./CampaignsSpoilers.vue?vue&type=template&id=01b3e0c6&lang=pug"
import script from "./CampaignsSpoilers.vue?vue&type=script&lang=js"
export * from "./CampaignsSpoilers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports